import styled from 'styled-components';
import posed from 'react-pose';
import { ifProp, prop } from 'styled-tools';
import { ReactComponent as ArrowSvg } from '../../../../../../svgs/leftarrow.svg';
import { color } from '../../../../../../styles/constants';
import animation from '../../../../../../styles/animations';

const DropDownAnimation = posed.div({
  open: {
    background: color.white,
    color: color.pelorous,
  },
  closed: {
    background: color.white25,
    color: color.white,
  },
});

export const Container = styled(DropDownAnimation)`
  width: 175px;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin: 0 10px 0 0;
  border-radius: ${ifProp('open', '4px 4px 0px 0px', '4px')};
  :hover {
    background-color: ${color.white50};
  }
`;

export const CalendarContainer = styled.div`
  position: absolute;
  top: ${prop('height')}px;
  animation: ${animation.appear} 0.2s;
  left: 130px;
  z-index: 60;
`;

export const CurrentFilter = styled.div`
  padding: 15px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  text-transform: capitalize;
`;

const OptionsAnimation = posed.div({
  closed: {
    height: 0,
  },
  open: {
    height: 'auto',
  },
});

export const Options = styled(OptionsAnimation)`
  overflow: hidden;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
  width: 100%;
  background: ${color.white};
  box-shadow: 0px 2px 5px ${color.boxShadow};
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const Arrow = styled(ArrowSvg)`
  width: 15px;
  height: 15px;
  transition: all 1s;
  transform: rotate(90deg);
  fill: ${color.white};
  ${ifProp('open', `opacity: 0;`, `opacity: 1;`)}
`;
